export const homeLightTheme = {
  '--home-bgc-1': 'transparent',
  '--home-bgc-2': 'rgba(35, 46, 58, 0.75)',
  '--home-bgc-3': '#f8f8f8',
  '--home-bgc-4': '#f8f8f8',
  '--home-bgc-5': 'rgba(73, 193, 226, 0.3)',
  '--home-bgc-6': '#49c1e2',
  '--home-bgc-7': '#fff',
  // '--home-font-c-1': '#333',
  '--home-border-c-1': '#65d5ff',
  '--home-border-c-2': '#f8f8f8',
  '--home-font-c-1': '#333',
  '--home-font-c-2': '#666',
  '--home-font-c-3': '#65d5ff',
  '--home-font-c-4': '#65d5ff',
  '--home-icon-c-1': '#fff',
}
export const homeDarkTheme = {
  '--home-bgc-1': '#23262f',
  '--home-bgc-2': 'rgba(35, 46, 58, 0.75)',
  '--home-bgc-3': 'linear-gradient(180deg, rgba(78, 79, 80, 0.4), rgba(78, 79, 80, 0.1))',
  '--home-bgc-4': '#23262f',
  '--home-bgc-5': 'rgba(73, 193, 226, 0.3)',
  '--home-bgc-6': '#49c1e2',
  '--home-bgc-7': '#798db2',
  '--home-border-c-1': 'transparent',
  '--home-border-c-2': '23262f',
  '--home-font-c-1': '#fff',
  '--home-font-c-2': '#9fa7b3',
  '--home-font-c-3': '#fff',
  '--home-font-c-4': '#65d5ff',
  '--home-icon-c-1': '#fff',
  '--home-bg-image-1': "url('../../../../assets/images/home/y-p-img.png')",
}
